import {Component, Input} from '@angular/core';
// icons
import {
  faSignIn
} from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-button',
  template: `
    <button
      class="registered-button"
      mat-button
      mat-raised-button
      color="primary"
      [routerLink]="path"
      [ngStyle]="{justifyContent: 'center'}">
      <fa-icon *ngIf="icon" [icon]="icons[icon]"></fa-icon>
      <ng-container *ngIf="label">{{label}}</ng-container>
    </button>
  `,
  styles: [`
    button.mat-button.mat-raised-button {
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
      border-radius: 20px;
      background-color: #26c6da;
      color: #ffffff;
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 40px;
      /*min-width: 140px;*/
      height: 40px;
      display: flex;
    }
    fa-icon {
      font-size: 14px;
      font-weight: 400;
      line-height: 40px;
      color: #ffffff;
      margin: 0 3px 0 0;
    }
  `]
})

export class ButtonComponent {
  @Input() path: string;
  @Input() label: string;
  @Input() icon: string;
  icons = {
    faSignIn: faSignIn,
  };
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/button/button.component.ts